import React from 'react';
import { motion } from 'framer-motion';
import Icon from '../../../components/AppIcon';

const WhyWeHoldEventSection = () => {
  const goals = [
    {
      id: 'democratic-legitimacy',
      title: 'تجديد الشرعية الديمقراطية',
      icon: 'Users',
      description: 'ضمان انتقال سلس للسلطة من خلال انتخابات ديمقراطية شفافة'
    },
    {
      id: 'institutional-development',
      title: 'التطوير المؤسساتي',
      icon: 'Building',
      description: 'تعزيز البنية التحتية المؤسسية وتطوير آليات العمل'
    },
    {
      id: 'sustainability',
      title: 'استدامة الأثر',
      icon: 'TrendingUp',
      description: 'ضمان استمرارية الإنجازات وبناء على المكتسبات السابقة'
    }
  ];

  return (
    <section id="why-we-hold-event" className="relative py-16 lg:py-24 bg-gradient-to-b from-background via-background to-[#114845]/5 overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0 bg-gradient-to-br from-primary/20 to-transparent"></div>
        <div className="absolute top-1/4 right-1/4 w-96 h-96 bg-accent/10 rounded-full blur-3xl"></div>
        <div className="absolute bottom-1/4 left-1/4 w-96 h-96 bg-secondary/10 rounded-full blur-3xl"></div>
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main Title */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-12 lg:mb-16"
        >
          <h2 className="font-memorial text-3xl md:text-4xl lg:text-5xl font-bold text-primary mb-6" dir="rtl">
            ما هي غاية المؤتمر العام الثاني؟
          </h2>
        </motion.div>

        {/* Main Content */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="mb-12 lg:mb-16"
        >
          <div className="bg-card/80 backdrop-blur-sm border border-border rounded-2xl p-8 md:p-10 lg:p-12 shadow-memorial">
            <p className="font-body text-lg md:text-xl text-text-primary leading-relaxed text-center mb-8" dir="rtl">
              العمل المؤسسي مسيرة تراكمية لا تتوقف عند الأشخاص؛ يأتي هذا المؤتمر ليتوّج ختام أعمال الدورة الأولى (2024-2025)، ويسلّم الراية لقيادة منتخبة تطلق الدورة الثانية (2026-2027)، تعزيزاً للمكتسبات وضماناً لاستمرار نهج البناء.
            </p>
            <div className="text-center mb-6">
              <p className="font-body text-base md:text-lg text-text-secondary font-semibold" dir="rtl">
                وذلك عبر:
              </p>
            </div>
          </div>
        </motion.div>

        {/* Goals Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {goals.map((goal, index) => (
            <motion.div
              key={goal.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.3 + index * 0.1 }}
              className="bg-card border border-border rounded-xl p-6 lg:p-8 shadow-memorial hover:shadow-lg transition-all duration-300 hover:border-primary/50"
            >
              <div className="flex flex-col items-center text-center space-y-4">
                {/* Icon */}
                <div className="w-16 h-16 bg-gradient-to-br from-primary/20 to-accent/20 rounded-full flex items-center justify-center border border-primary/30 mb-2">
                  <Icon
                    name={goal.icon}
                    size={32}
                    className="text-primary"
                  />
                </div>

                {/* Title */}
                <h3 className="font-memorial text-xl md:text-2xl font-bold text-primary" dir="rtl">
                  {goal.title}
                </h3>

                {/* Description */}
                <p className="font-body text-sm md:text-base text-text-secondary leading-relaxed" dir="rtl">
                  {goal.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyWeHoldEventSection;
